export default defineNuxtPlugin({

})
